module.exports = __webpack_public_path__ + "img/vk-icon.91809893.svg";